<template>
  <BaseScreen v-bind="screen">
    <BaseAlert
      v-if="isErrorVisible"
      v-bind="error"
      slot="middle"
    />
    <BaseAlert
      v-else-if="isThanksVisible"
      v-bind="thanks"
      slot="middle"
    />
    <BaseAlert
      v-else
      v-bind="rate"
      slot="middle"
      key="rate"
    />
  </BaseScreen>
</template>

<script>
import screenMixin from '@/mixins/screen';
import mailMixin from '@/mixins/mail';

export const SCORES = Object.freeze({
  BAD: 'bad',
  FINE: 'fine',
  GREAT: 'great',
});

export default {
  name: 'RateScreen',
  mixins: [screenMixin, mailMixin],
  computed: {
    screenCase() {
      if (this.isErrorVisible) {
        return 'STEP_SENDING_ERROR';
      }
      if (this.isThanksVisible) {
        return 'STEP_RATE_SENDED';
      }
      return 'STEP_RATE';
    },
    score() {
      return this.$route.query.score;
    },
    isBadScore() {
      return this.score === SCORES.BAD;
    },
    rate() {
      return {
        icon: {
          name: `smile_${this.score}`,
          theme: 'primary',
          view: 'rect',
          size: 'l',
        },
        title: {
          text: this.$t(`rate.${this.score}Title`),
          size: 'l',
        },
        description: {
          text: this.$t('rate.question'),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('rate.disagree'),
            action: this.goToHomeScreen,
            theme: 'secondary',
          },
          {
            text: this.$t('rate.agree'),
            action: this.isBadScore ? this.showThanks : this.sendScore,
          },
        ],
      };
    },
    thanks() {
      return {
        icon: {
          name: 'heart',
          theme: 'thanks',
          size: 'l',
        },
        title: {
          text: this.$t(this.isBadScore ? 'rate.longThanks' : 'rate.shortThanks'),
          size: 'l',
        },
        description: {
          text: this.$t(this.isBadScore ? 'rate.addFeedback' : 'rate.respect'),
          size: 'l',
        },
        actions: this.isBadScore ? [
          {
            text: this.$t('rate.no'),
            action: this.sendScore,
          },
          {
            text: this.$t('rate.yes'),
            action: this.goToFeedbackScreen,
          },
        ] : [
          {
            text: this.$t('rate.goHome'),
            action: this.goToHomeScreen,
          },
        ],
      };
    },
    error() {
      return {
        icon: {
          name: 'important',
          theme: 'error',
          view: 'circle',
          size: 'l',
        },
        title: {
          text: this.$t('rate.badHardware'),
          size: 'l',
        },
        description: {
          text: this.$t('rate.notPossible'),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('rate.goHome'),
            action: this.goToHomeScreen,
          },
        ],
      };
    },
  },
  created() {
    this.initActions([
      ['ACTION_DISAGREE', this.goToHomeScreen],
      ['ACTION_AGREE', this.sendScore],
      ['ACTION_NO', this.sendScore],
      ['ACTION_YES', this.goToFeedbackScreen],
    ]);
  },
  methods: {
    sendScore() {
      if (this.isPending) return;

      this.showPending();

      const email = process.env.VUE_APP_FEEDBACK_EMAIL;
      const score = this.$t(`rate.${this.score}Score`);
      const subject = this.$t('rate.emailSubject');
      const body = this.$t('rate.emailbody', { score });

      this.sendMail(email, subject, body); // функция из миксина
    },
    onMailSuccess() {
      this.isBadScore
        ? this.goToHomeScreen()
        : this.showThanks();
    },
    goToFeedbackScreen() {
      this.$router.push(this.$router.options.paths.feedback);
    },
  },
};
</script>
